/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { type OnInit, Component, Input } from '@angular/core';
import { I18nService } from '@dm/core';

@Component({
    selector: 'app-badge-num',
    templateUrl: './badge-num.component.html',
    styleUrls: ['./badge-num.component.scss'],
})
export class BadgeNumComponent implements OnInit {
    @Input() total: number;
    moreThan99Str = '';
    constructor(
        private i18nService: I18nService,
    ) { }

    ngOnInit(): void {
        this.moreThan99Str = this.i18nService.get('monitor.recentException_num_lab');
    }
}
